import React from "react";
import { Button, Space, Typography} from "antd";
const { Text } = Typography;

export function CustomModalFooter({
  errorText,
  handleCancel,
  handleSave,
  saveButtonIsLoading
}) {
  return <div style={{ textAlign: 'right' }}>
    <Space style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
      <Button onClick={handleCancel}>
        Cancel
      </Button>
      <Button type="primary" loading={saveButtonIsLoading} diabled={saveButtonIsLoading} onClick={handleSave}>
        Save
      </Button>
    </Space>
    {errorText && (
      <div style={{ marginTop: 8 }}>
        <Text type="danger">{errorText}</Text>
      </div>
    )}
  </div>
}